import type { FC, PropsWithChildren } from 'react'

import { QueryClientProvider as RQQueryClientProvider } from '@tanstack/react-query'

import { queryClient } from '@/shared/lib/query/client'

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
  return <RQQueryClientProvider client={queryClient}>{children}</RQQueryClientProvider>
}
